import { render, staticRenderFns } from "./CategoryCreate.vue?vue&type=template&id=b582baa8&scoped=true"
import script from "./CategoryCreate.vue?vue&type=script&lang=js"
export * from "./CategoryCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b582baa8",
  null
  
)

export default component.exports